export const AvailablePropertiesIcon = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.0001 1.6875L2.25 13.5V34.3125H13.5V22.5H22.5V34.3125H33.75V13.5L18.0001 1.6875ZM31.5 32.0625H24.75V20.25H11.25V32.0625H4.5V14.625L18.0001 4.5L31.5 14.625V32.0625Z"
        fill="#0042E6"
      />
      <path d="M15.75 11.25H20.25V15.75H15.75V11.25Z" fill="#0042E6" />
    </svg>
  );
};
